import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { apiUrl } from "../config/url";
import Navbar from "./Navbar";

const UnitMaster = () => {
  const user_role = localStorage.getItem("user_role");

  const [UnitMasters, setUnitMasters] = useState([]);
  const [filteredUnitMasters, setFilteredUnitMasters] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [newUnitMaster, setNewUnitMaster] = useState({
    code: "",
    name: "",
    address_1: "",
    address_2: "",
    contact: "",
  });
  const [editMode, setEditMode] = useState(false);
  const [currentUnitMaster, setCurrentUnitMaster] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false); // Loading state

  useEffect(() => {
    fetchUnitMasters();
  }, []);

  useEffect(() => {
    setFilteredUnitMasters(
      UnitMasters.filter((UnitMaster) =>
        UnitMaster.name.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm, UnitMasters]);

  const fetchUnitMasters = async () => {
    setLoading(true); // Start loading
    try {
      const token = localStorage.getItem("api_token");
      const response = await axios.get(`${apiUrl}/admin/getAllUnits`, {
        headers: {
          api_token: token,
        },
      });

      if (Array.isArray(response.data.data)) {
        setUnitMasters(response.data.data);
        setFilteredUnitMasters(response.data.data); // Initialize filtered list
      } else {
        console.error("Expected an array but got:", response.data);
        toast.error("Failed to fetch records");
      }
    } catch (error) {
      console.error("Error fetching unit masters", error);
      toast.error("Failed to fetch records");
    } finally {
      setLoading(false); // End loading
    }
  };

  const createUnitMaster = async () => {
    setLoading(true); // Start loading
    try {
      const token = localStorage.getItem("api_token");

      console.log(newUnitMaster);

      await axios.post(`${apiUrl}/admin/createUnit`, newUnitMaster, {
        headers: {
          api_token: token,
        },
      });
      fetchUnitMasters();
      resetForm();
      setIsModalOpen(false);
      toast("UnitMaster created successfully", { type: "success" });
    } catch (error) {
      console.error("Error creating unit master", error);
      toast.error("Failed to create unit master");
    } finally {
      setLoading(false); // End loading
    }
  };

  const updateUnitMaster = async () => {
    setLoading(true); // Start loading
    try {
      const token = localStorage.getItem("api_token");
      await axios.post(
        `${apiUrl}/admin/updateUnit`,
        { ...currentUnitMaster, ...newUnitMaster },
        {
          headers: {
            api_token: token,
          },
        }
      );
      toast.success("UnitMaster updated successfully");
      fetchUnitMasters();
      resetForm();
      setIsModalOpen(false);
    } catch (error) {
      console.error("Error updating unit master", error);
      toast.error("Failed to update unit master");
    } finally {
      setLoading(false); // End loading
    }
  };

  const handleEdit = (UnitMaster) => {
    setCurrentUnitMaster(UnitMaster);
    setNewUnitMaster({
      unit_id: UnitMaster.id,
      name: UnitMaster.name,
      short: UnitMaster.short,
    });
    setEditMode(true);
    setIsModalOpen(true);
  };

  const openCreateModal = () => {
    resetForm();
    setEditMode(false);
    const nextCode = UnitMasters.length + 1; // Set default code as count + 1
    setNewUnitMaster((prev) => ({ ...prev, code: nextCode.toString() })); // Convert to string if needed
    setIsModalOpen(true);
  };

  const resetForm = () => {
    setNewUnitMaster({
      name: "",
      short: "",
    });
    setCurrentUnitMaster(null);
    setEditMode(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (editMode) {
      updateUnitMaster();
    } else {
      createUnitMaster();
    }
  };

  return (
    <>
      <Navbar />

      <div>
        <ToastContainer />
        <h1 className="text-3xl font-bold text-center my-6">
          Unit Master Management
        </h1>



        {loading ? ( // Show loading indicator
          <div className="text-center">
            <p>Loading...</p>
          </div>
        ) : (
          <div className="flex justify-center mb-4">
            <table className="bg-white border border-gray-200 table-auto inline-table">
              <thead>
                <tr className="border-none">
                  <th colSpan={user_role === "1" ? 4 : 3} className="p-4 border-none bg-white">
                    <div className="flex justify-between items-center">
                      <input
                        type="text"
                        placeholder="Search by Name or Code"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="p-2 border border-gray-300 rounded"
                      />
                      {user_role === "1" && (
                        <button
                          onClick={openCreateModal}
                          className="bg-blue-600 text-white py-2 px-4 rounded ml-4" // Added ml-4 for margin-left
                        >
                          Create UnitMaster
                        </button>
                      )}
                    </div>
                  </th>
                </tr>
                <tr>
                  <th className="py-2 px-4 border bg-gray-100 text-gray-800 font-semibold text-left">Sr no</th>
                  <th className="py-2 px-4 border bg-gray-100 text-gray-800 font-semibold text-left">Name</th>
                  <th className="py-2 px-4 border bg-gray-100 text-gray-800 font-semibold text-left">Short</th>
                  {user_role === "1" && (
                    <th className="py-2 px-4 border bg-gray-100 text-gray-800 font-semibold text-center" style={{ width: '100px' }}>
                      Actions
                    </th>
                  )}
                </tr>
              </thead>
              <tbody className="text-base">
                {filteredUnitMasters.map((UnitMaster) => (
                  <tr key={UnitMaster.id} className="even:bg-gray-50">
                    <td className="py-2 px-4 border text-gray-800">{UnitMaster.id}</td>
                    <td className="py-2 px-4 border text-gray-800">{UnitMaster.name}</td>
                    <td className="py-2 px-4 border text-gray-800">{UnitMaster.short}</td>
                    {user_role === "1" && (
                      <td className="py-2 px-4 border text-center">
                        <button
                          onClick={() => handleEdit(UnitMaster)}
                          className="bg-yellow-500 text-white py-1 px-3 rounded hover:bg-yellow-600"
                        >
                          Edit
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>


        )}

        {isModalOpen && (
          <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
            <div className="bg-white p-6 rounded shadow-lg w-96">
              <h2 className="text-lg font-bold mb-4">
                {editMode ? "Edit UnitMaster" : "Create UnitMaster"}
              </h2>
              <form onSubmit={handleSubmit}>
                <input
                  type="text"
                  placeholder="Name"
                  value={newUnitMaster.name}
                  onChange={(e) =>
                    setNewUnitMaster({ ...newUnitMaster, name: e.target.value })
                  }
                  required
                  className="w-full mb-2 p-2 border border-gray-300 rounded"
                />
                <input
                  type="text"
                  placeholder="Short name"
                  value={newUnitMaster.short}
                  onChange={(e) =>
                    setNewUnitMaster({
                      ...newUnitMaster,
                      short: e.target.value,
                    })
                  }
                  className="w-full mb-2 p-2 border border-gray-300 rounded"
                />
                <div className="flex justify-end">
                  <button
                    type="submit"
                    className="bg-blue-600 text-white py-1 px-4 rounded"
                  >
                    {editMode ? "Update" : "Create"}
                  </button>
                  <button
                    type="button"
                    onClick={() => setIsModalOpen(false)}
                    className="ml-2 bg-gray-400 text-white py-1 px-4 rounded"
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </>
  );

};

export default UnitMaster;
